module.exports = __webpack_public_path__ + "img/pocket_watch_by_bobeck-d48h1ca.jpg";